export const formatMoney = (
    amount: string | number,
    showCurrency = true,
): string => {
    const style = showCurrency ? 'currency' : 'decimal';
    const currency = showCurrency ? 'USD' : undefined;
    const formatAmount = Number(amount);
    const parser = new Intl.NumberFormat('en-US', {
        style,
        currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
    return parser.format(formatAmount);
};
